import { Navigate } from 'react-router-dom';
import { useAuthStore } from '@/store/authStore';
import NotFoundPage from '@/app/ErrorHandling/NotFoundPage';

interface RoleProtectedRouteProps {
  children: React.ReactNode;
  roles?: string[];
  redirectTo?: string;
}

const RoleProtectedRoute = ({
  children,
  roles,
  redirectTo = '/login',
}: RoleProtectedRouteProps) => {
  const { isAuthenticated, roles: userRoles, isCustomerUser } = useAuthStore();
  
  if (!isAuthenticated) {
    console.debug('User not authenticated, redirecting to', redirectTo);

    return <Navigate to={redirectTo} replace />;
  }

  // Customer users should not access role-protected routes - show 404

  const hasRequiredRole = !roles || roles.some((role) => userRoles.includes(role));
  if (!hasRequiredRole) {
    console.debug('User lacks required roles, redirecting', roles, redirectTo);

    return <Navigate to="/home" replace />;
  }

  return <>{children}</>;
};

export default RoleProtectedRoute;
